/**
 * @name: 埋点逻辑文件
 * @description:
 * @author: wyh
 * @time: 2021-08-31 11:28:32
 */

import { globalData, statsData } from "@/utils/statistic/statsdata";

function Statistics () {}

// 初始化
Statistics.prototype.init = function(projectPage) {
  var _this = this;
  document.body.addEventListener("mousedown", (event) => {
    var target = event.srcElement || event.target;
    var attr = target.attributes;
    // 递归向上收集点击元素标记
    while (true) {
      if (target.tagName === "BODY" || !(attr = target.attributes)) {
        break;
      }
      if (attr["stats-mark"]) {
        _this._getStaticData(attr, statsData, projectPage);
      }
      try {
        target = target.parentNode;
      } catch (event) {
        break;
      }
    }
  });
};

// 获取单个埋点请求字段
Statistics.prototype._getStaticData = function(attr, statsData, projectPage) {
  var _this = this;
  // 埋点类型
  var statsMark = attr["stats-mark"].value;

  // 数据id
  var statsId = attr["preview-id"] ? attr["preview-id"].value : "";
  // 埋点页面id
  // var projectPage = $("body").attr("stats-projectpage");

  // 场景类型

  var data = {};

  data.projectPage = projectPage;
  data.templateid = statsId;
  //data.type = attr['type'].value

  statsData.forEach(function(item, index) {
    if (item.statsMark === statsMark) {
      for (var k in item) {
        data[k] = item[k];
      }
      _this.__sendEvent(data);
    }
  });
};

//  默认行为触发
Statistics.prototype.defalutEvent = function(statsData) {
  this.__sendEvent(statsData);
};

// 发送请求
Statistics.prototype.__sendEvent = function(data) {
  globalData.eventId.push(data.eventId);

  if (globalData.eventId.length > 50) {
    globalData.eventId.shift();
  }

  var query = {};
  // 埋点数据
  query.templateid = data.templateid;//模板id
  query.senneType = data.type;//模板场景类型
  // 项目信息相关字段
  query.p = 2; // 项目管理 15:爱设计pc端
  query.pp = data.projectPage; // 项目页面
  query.ppa = data.projectArea; // 项目页面区域

  // 客户端信息相关字段
  query.sw = screen.width; // 屏幕宽
  query.sh = screen.height; // 屏幕高
  query.os = navigator.platform; // 操作系统

  // 浏览器信息相关字段
  query.pl = 1; // 平台  1.pc
  query.b = navigator.appCodeName; // 浏览器
  query.bv = navigator.appVersion; // 浏览器版本

  let vid = getCookie("user_uuid");
  if (!vid) {
    if (!localStorage.getItem("vistorId")) {
      localStorage.setItem("vistorId", getRandomString());
    }
    vid = localStorage.getItem("vistorId");
  }
  let sessionId = window.sessionStorage.getItem("sessionId");
  if (!sessionId) {
    sessionId = getRandomString();
  }
  // 用户信息相关字段
  query.vid = vid; // 唯一访客id 前端生成一个UUID 存入cookie或者storage
  query.sid = sessionId; // 会话id 标记一次会话 前端生成 该id生存期较短
  query.il = getCookie("user_uuid") ? 1 : 0; // 是否登录 0未登录 1登录

  query.uid = getCookie("user_uuid") ? getCookie("user_uuid") : ""; // 已登录用户id

  // 浏览相关信息
  query.du = window.location.href; // 当前页面的地址
  query.dp = window.location.pathname; // 当前url的path
  query.dr = document.referrer; // 页面referer
  query.drh = document.referrer; // 页面referer的域
  query.c = ""; // 来源渠道
  query.ia = data.isAjax ? data.isAjax : "0"; // 当前请求或者事件是否是ajax请求

  // 事件信息
  query.et = data.eventType ? data.eventType : "1"; // 事件类型 1跳转 2浏览 非跳转ajax 3点击事件 4滚动下拉上拉事件 5填写表单事件
  query.ecaid = data.eventArea ? data.eventArea : ""; // 事件坐标位置区域id
  query.eid = data.eventId ? data.eventId : ""; // 事件坐标位置区域id 如1.头图区域
  query.ea = data.eventName ? data.eventName : ""; // 事件别名
  query.efsid = data.efsid ? data.efsid : ""; // 事件作用id 比如浏览文章列表的页码
  query.event_functional_source_id = data.event_functional_source_id ? data.event_functional_source_id : ""; //

  query.eis = globalData.eventId.join(","); // 用,按顺序连接的集合 最长50个id 用户事件的路径
  query.eti = getEventTime(); // 事件发生时间 时:分:秒
  query.ed = getEventDay(); // 事件发生的日期 年-月-日
  query.t = Math.round(new Date / 1000); // 事件发生时间戳 标准秒数 非毫秒微秒

  // 邀请相关
  /* query.ii = data.isInvite ? data.isInvite : 0; // 是否触发邀请 1是0否
  query.iuid = data.invitedId ? data.invitedId : ''; // inviter_user_id邀请人id
  query.biuid = data.beInvitedId ? data.beInvitedId : ''; // be_invited_user_id被邀请人id
  query.inpa = data.invitedParem ? encodeURIComponent(data.invitedParem) : ''; // 邀请参数 如有?，=等特殊符号则 urlencode */

  //  发送img请求
  var img = new Image();
  var rand = "_click_" + Math.floor(2147483648 * Math.random()).toString(36);
  window[rand] = img;
  img.onload = img.onerror = img.onabort = function() {
    img.onload = img.onerror = img.onabort = null;
    img = window[rand] = null;
  };

  var conditions = [];

  for (var k in query) {
    conditions.push(k + "=" + query[k]);
  }

  var request_url = window.location.host.charAt(0) == "p" ? "/track.gif?" : "https://tj.isheji.com/track.gif?";

  img.src = request_url + conditions.join("&");

};

var statistics = new Statistics();

// 获取cookie
function getCookie (name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return (arr[2]);
  else
    return null;
}

function getEventTime () {
  let d = new Date();
  let hour = change(d.getHours());
  let minute = change(d.getMinutes());
  let second = change(d.getSeconds());

  function change (t) {
    if (t < 10) {
      return "0" + t;
    } else {
      return t;
    }
  }

  let time = hour + ":" + minute + ":" + second;
  return time;
}

function getEventDay () {
  let d = new Date();
  let year = d.getFullYear();
  let month = change(d.getMonth() + 1);
  let day = change(d.getDate());

  function change (t) {
    if (t < 10) {
      return "0" + t;
    } else {
      return t;
    }
  }

  let date = year + "-" + month + "-" + day;
  return date;
}

function getRandomString () {
  var str = "",
    range = 30,
    arr = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];

  // 随机产生
  for (var i = 0; i < range; i++) {
    str += arr[Math.round(Math.random() * (arr.length - 1))];
  }
  return str;
}

export default statistics;
